import { useEffect, useMemo } from 'react';
import { WebLogger, WebComponentCode } from '../logging';

const landingLogger = new WebLogger(WebComponentCode.WEB_UI, 'Landing');

export type LandingTrack = (action: string, data?: Record<string, unknown>) => void;

/**
 * Landing-page telemetry: `landing_view` once per signed-out visit, and
 * `landing_<action>` (e.g. `landing_cta_click`) on demand. `variant` names the
 * page — `hub`, `teacher`, or one of the older student variants — so the
 * funnel can be split by door. See docs/FeatureDesigns/front-door/front-door-target.md.
 */
export function useLandingTelemetry(variant: string, isAuthenticated: boolean, isLoading: boolean): LandingTrack {
  const track = useMemo<LandingTrack>(
    () => (action, data = {}) => {
      landingLogger.info(`landing_${action}`, {
        action,
        variant,
        path: typeof window !== 'undefined' ? window.location.pathname : undefined,
        host: typeof window !== 'undefined' ? window.location.hostname : undefined,
        ...data,
      });
    },
    [variant]
  );

  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    track('view', {
      referrer: typeof document !== 'undefined' ? document.referrer || null : null,
      query: typeof window !== 'undefined' ? window.location.search || null : null,
    });
  }, [isLoading, isAuthenticated, track]);

  return track;
}
